<template>
  <div class="download-link-page">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">Download Links</div>
      </q-card-section>
      <q-separator />

      <q-card-section class="card-content">
        <span>Download Links Available (Click to download)</span>

        <div
          v-for="link in getDownloadLinks"
          :key="link.id"
          class="frame"
        >
          <img
            style="object-fit: contain; height: 50%; width: 100%; cursor: pointer;"
            v-if="link.type === 'googledrive'" src="../../assets/download/googledrive.png"
            @click="openLink(link.link)"
          />
          <img
            style="object-fit: contain; height: 100%; width: 100%; cursor: pointer;"
            v-if="link.type === 'megadownload'" src="../../assets/download/megadownload.png"
            @click="openLink(link.link)"
          />
          <img
            style="object-fit: contain; height: 60%; width: 100%; cursor: pointer;"
            v-if="link.type === 'mediafire'" src="../../assets/download/mediafire.png"
            @click="openLink(link.link)"
          />
        </div>
      </q-card-section>

    </q-card>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DownloadLinkPage',
  computed: {
    ...mapGetters({
      getDownloadLinks: 'home/getDownloadLinks'
    })
  },
  methods: {
    openLink (link) {
      window.open(link, '_blank')
    }
  }
}
</script>
<style lang="scss">
.download-link-page {
  .my-card {
    background-color: $backgroundHeader;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .card-section {
      color: white;
    }

    .card-content {
      background-color: $background;
      display: grid;

      .frame {
        height: 160px; /* Can be anything */
        width: 100%; /* Can be anything */
        position: relative;
        display: inline-block;
        position: relative;

        img {
          max-height: 100%;
          max-width: 100%;
          width: auto;
          height: auto;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }

      span {
        font-size: 24px;
        color: white;
        text-align: center;
      }
    }
  }
}
</style>